import React from 'react';

export const GoalIcon = (): JSX.Element => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 0V15H1.875V11.25H14.0625V0H0ZM3.75 9.375H1.875V7.5H3.75V9.375ZM3.75 3.75H1.875V1.875H3.75V3.75ZM6.5625 6.5625H4.6875V4.6875H6.5625V6.5625ZM9.375 9.375H7.5V7.5H9.375V9.375ZM9.375 3.75H7.5V1.875H9.375V3.75ZM12.1875 6.5625H10.3125V4.6875H12.1875V6.5625Z"
        fill="#4B5466"
      />
    </svg>
  );
};
